var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilCircled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#C9CEFA",
    stroke: "#ABB2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24.5501V27.0835C12.5 27.3168 12.6833 27.5001 12.9167 27.5001H15.45C15.5583 27.5001 15.6667 27.4585 15.7417 27.3751L24.8417 18.2835L21.7167 15.1585L12.625 24.2501C12.5417 24.3335 12.5 24.4335 12.5 24.5501ZM27.2583 15.8668C27.5833 15.5418 27.5833 15.0168 27.2583 14.6918L25.3083 12.7418C24.9833 12.4168 24.4583 12.4168 24.1333 12.7418L22.6083 14.2668L25.7333 17.3918L27.2583 15.8668Z",
    fill: "#5F6CE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilCircled);
export default __webpack_public_path__ + "static/media/pencilCircled.7f613e8370f2682fe84e9a68a7e111be.svg";
export { ForwardRef as ReactComponent };